import axios from 'axios'

const ENDPOINT = '/api/internal/generator/asset-conversions'

const csrfToken = () => {
  const meta = document.getElementsByName('csrf-token')[0]
  return meta?.getAttribute('content')
}

// Idempotent. `target_format` (not `format`) avoids Rails' reserved param name.
export const createAssetConversion = async (assetId, format) => {
  const response = await axios.post(
    ENDPOINT,
    { asset_id: assetId, target_format: format },
    {
      headers: { 'X-CSRF-Token': csrfToken() },
      withCredentials: true,
    },
  )
  return response.data
}
